"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikInput = void 0;
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const style_1 = require("./style");
function Input({ value, name, id, type, autoFocus, disabled, label, helperText, onBlur, onChange, error, variant = "outlined", ...rest }) {
    return (react_1.default.createElement(style_1.StyledInput, { ...rest, InputLabelProps: {
            shrink: false,
            focused: false,
        }, InputProps: {
            notched: false,
        }, onBlur: onBlur, label: label, variant: variant, helperText: helperText, error: error, value: value, name: name, onChange: onChange, id: id, type: type, autoFocus: autoFocus, disabled: disabled }));
}
exports.default = react_1.default.memo(Input);
function FormikInput(props) {
    const [field] = (0, formik_1.useField)(props.name);
    const onChange = (0, react_1.useCallback)((event) => {
        field.onChange(props.name)(event.target.value);
    }, [field]);
    return react_1.default.createElement(Input, { ...field, ...props, onChange: onChange });
}
exports.FormikInput = FormikInput;
